// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ld-1";
export var messageSideRight = "_ld-2";
export var orderLookupBubbleContainer = "_ld-0";
export var submitButton = "_ld-3";